const VERSION = "4.0.0";
export {
  VERSION
};
